import userReducer from './userSlice'
import pspConfigReducer from './pspConfigSlice'

const reducers = {
  userReducer,
  pspConfigReducer
}

export default reducers
